module.exports = __webpack_public_path__ + "static/media/home-page.4e212cc9.jpg";